export const DATA_SOURCE = {
  MERGED: "merged",
  CALLS: "calls",
  VOLUUM: "voluum",
}

export const AB_TEST_VARIANT_LABEL = {
  RINGBA: "Ringba",
  CALLS_RUNNER: "CallsRunner",
}
